import type { LayerRegistryEntry } from '@okmaps/shared';
import type { PendingExtent } from '../slices/mapSlice.js';

/**
 * A registry entry as a framing request, or null when it has no usable extent.
 *
 * Shared by the two thunks that frame a layer so they cannot drift: both have
 * to carry the scale window, and a version of this that forgot it is exactly
 * the bug the window exists to fix.
 */
export function toPendingExtent(entry: LayerRegistryEntry): PendingExtent | null {
  if (!entry.bbox) return null;

  return {
    bbox: entry.bbox,
    ...(entry.minScale === undefined ? {} : { minScale: entry.minScale }),
    ...(entry.maxScale === undefined ? {} : { maxScale: entry.maxScale }),
  };
}
